/* global google */
import React, { useState, useContext, useEffect, } from "react";
import GridContainer from "../../components/CustomGrid/GridContainer";
import GridItem from "../../components/CustomGrid/GridItem";
import AdvancedSearchContext from "../../context/AdvancedSearchContext";
import { ErrorBoundary } from "react-error-boundary";
import { Navigate } from 'react-router-dom';
import ErrorFallbackDialog from "components/ErrorFallback/ErrorFallbackDialog";
import postPageVisit from "services/LogService";
import CardBody from "components/Card/CardBody";
import Card from "components/Card/Card";
import MapContainer from "components/Maps/MapContainer";
import { width } from "@mui/system";

export default function Maps() {
    // console.log("Page plan d'actions");
    const [redirState, setRedirState] = useState(false);
    const appContext = useContext(AdvancedSearchContext);
    const { setPage } = appContext;

    useEffect(() => {
        setPage('maps');
        postPageVisit('maps');
    }, []);

    let redirecting = redirState && (
        <Navigate
            push
            to={{
                pathname: "/admin/maps",
            }}
        />
    );
    return (
        <ErrorBoundary
            onReset={() => setRedirState(true)}
            FallbackComponent={ErrorFallbackDialog}
            page={"maps"}
        >
            <GridContainer style={{width:'100%'}}>
                <GridItem xs={12} sm={12} md={12} lg={12} xl={12}  style={{width:'100%'}}>
                    <MapContainer />
                </GridItem>
            </GridContainer>
            {redirecting}
        </ErrorBoundary>
    );
}
